export const CyOffline = {
  DownloadButton: "DownloadButton",
  ConfirmDownloadFinishedButton: "ConfirmDownloadFinishedButton",
} as const;
